/* eslint-disable import/prefer-default-export */
export function assign(...options) {
  return window.location.assign(...options);
}
